import React from 'react';
import styled from "styled-components";
import Colors from "../../assets/colors/Colors";
import Constants from "../../data/Constants";
import Images from "../../assets/images/Images";

// @ts-ignore
import { Link } from "react-router-dom";
import ImageComponent from "../../components/imageEconomicResearch/EconomicResearchImageComponent";

const InternalErrorContainer = styled.div`
    height: 95vh;
    min-height: 50%;
    width: 100%;
    min-width: 50%;
    background-color: ${Colors.backgroundRed}
`;

const StyledLink = styled(Link)`
    flex: 1;
    padding-top: 150px;
    text-align: center;
    font-size: 30px;
    color: white;

    &:hover {
        color: white;
    }
`;

const InternalErrorComponent: React.FC = ({ children }) => {
    return (
        <InternalErrorContainer>
            <div style={{display: "flex", flexDirection: "column"}} >
                <div style={{flex: 1, paddingTop: 50, textAlign: 'center', fontSize: 150, color: "white"}}>
                    500
                </div>
                <div style={{flex: 1, textAlign: 'center', fontSize: 30, color: "white"}}>
                    <ImageComponent image={Images.homeImage3}/>
                </div>
                <div style={{flex: 1, textAlign: 'center', fontSize: 30, color: "white"}}>
                    Something went wrong<br/>
                    <StyledLink to={Constants.routes.root}>
                        Go back home
                    </StyledLink>
                </div>
            </div>
        </InternalErrorContainer>
    )
};

export default InternalErrorComponent;
